import React from "react";
import Form from "./Form";

const Upload = () => {
  return (
    <div className="container">
      <Form />
    </div>
  );
};

export default Upload;